import React from "react";

import NavigationIcon from "./NavigationIcon";

export function commandRailItemIsActive(itemKey, { taxonomyOpen, commandRailPanel, guruListFilter }) {
  if (itemKey === "myplays") return guruListFilter === "my-list";
  return taxonomyOpen && commandRailPanel === itemKey;
}

export default function CommandRailIconButton({ item, active, count = 0, onClick }) {
  return (
    <button
      type="button"
      title={item.label}
      aria-label={item.label}
      aria-pressed={active}
      onClick={onClick}
      style={{
        width: 52,
        height: 52,
        borderRadius: 16,
        border: active ? "2px solid #38bdf8" : "1px solid #334155",
        background: active ? "#10354a" : "#182335",
        color: "#f8fafc",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 21,
        fontWeight: 950,
        cursor: "pointer",
        position: "relative",
      }}
    >
      <NavigationIcon icon={item.icon} />
      {item.key === "myplays" && count > 0 && (
        <span
          data-testid="myplays-count-badge"
          style={{ position: "absolute", right: -2, top: -3, minWidth: 18, height: 18, borderRadius: 999, padding: "0 4px", background: "#f59e0b", color: "#111827", fontSize: 10, fontWeight: 950, display: "inline-flex", alignItems: "center", justifyContent: "center" }}
        >
          {count}
        </span>
      )}
    </button>
  );
}
